import {
  ContactTypesCondensed,
  InternalSubtypes,
  VendorSubtypes
} from "../constants/contact-enums";
import { Tab } from "../helper-classes/Tab";
import { ContactIcons } from "./icon-maps";

export const contactsIndexTabs = [
  new Tab("all contacts", "all", ContactIcons.all),
  new Tab(
    "customers",
    ContactTypesCondensed.CUSTOMER,
    ContactIcons[ContactTypesCondensed.CUSTOMER]
  ),
  new Tab(
    "part. & vend.",
    ContactTypesCondensed.PARTNER_VENDOR,
    ContactIcons[ContactTypesCondensed.PARTNER_VENDOR]
  ),
  new Tab(
    "internal staff",
    ContactTypesCondensed.INTERNAL,
    ContactIcons[ContactTypesCondensed.INTERNAL]
  )
];
export const contactPartnersVendorsSubTabs = [
  new Tab("all", "all"),
  new Tab("architects", VendorSubtypes.ARCHITECT),
  new Tab("builders", VendorSubtypes.BUILDER),
  new Tab("consultants", VendorSubtypes.CONSULTANT),
  new Tab("equipment", VendorSubtypes.EQUIPMENT),
  new Tab("furniture", VendorSubtypes.FURNITURE),
  new Tab("general", VendorSubtypes.GENERAL),
  new Tab("interior designers", VendorSubtypes.INTERIOR),
  new Tab("masonry", VendorSubtypes.MASONRY),
  new Tab("nursery", VendorSubtypes.NURSERY)
];

export const contactInternalStaffSubTabs = [
  new Tab("all", "all"),
  new Tab("project managers", InternalSubtypes.PROJECT_MANAGER),
  new Tab("office staff", InternalSubtypes.OFFICE_STAFF),
  new Tab("crew", "crew"),
  new Tab("design team", InternalSubtypes.DESIGN)
];
